<template>
  <div class="error-page">
    <error-message />
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="8" lg="8">
          <v-card color="primary" dark to="/">
            <v-card-text class="display-1 text-center"
              >トップページ
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import ErrorMessage from "@/components/ErrorMessage";
export default {
  components: {
    ErrorMessage
  }
};
</script>
